const MailGreen = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33594 4.66699L6.77922 8.47729C7.22 8.78583 7.44039 8.94011 7.68011 8.99986C7.89187 9.05265 8.11334 9.05265 8.3251 8.99986C8.56482 8.94011 8.78521 8.78583 9.22599 8.47729L14.6693 4.66699M4.53594 13.3337H11.4693C12.5894 13.3337 13.1494 13.3337 13.5773 13.1157C13.9536 12.9239 14.2595 12.618 14.4513 12.2416C14.6693 11.8138 14.6693 11.2538 14.6693 10.1337V5.86699C14.6693 4.74689 14.6693 4.18683 14.4513 3.75901C14.2595 3.38269 13.9536 3.07673 13.5773 2.88498C13.1494 2.66699 12.5894 2.66699 11.4693 2.66699H4.53594C3.41583 2.66699 2.85578 2.66699 2.42796 2.88498C2.05163 3.07673 1.74567 3.38269 1.55392 3.75901C1.33594 4.18683 1.33594 4.74689 1.33594 5.86699V10.1337C1.33594 11.2538 1.33594 11.8138 1.55392 12.2416C1.74567 12.618 2.05163 12.9239 2.42796 13.1157C2.85578 13.3337 3.41583 13.3337 4.53594 13.3337Z"
      stroke="#13694E"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MailGreen;
